import { render, staticRenderFns } from "./InputImageFile.vue?vue&type=template&id=5371bc48&"
import script from "./InputImageFile.vue?vue&type=script&lang=ts&"
export * from "./InputImageFile.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports